// extracted by mini-css-extract-plugin
module.exports = {"Services":"OurServices_Services__29CM2","Button":"OurServices_Button__2oHKq"};